import React from 'react';
import styled from 'styled-components';
import {
  CloseButton,
  FormGroup,
  FormLabel,
  InputField,
  ModalBody,
  ModalCard,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalTitle,
  PrimaryButton,
  SecondaryButton,
} from './AdminModalPrimitives';

interface AdminDateFilterModalProps {
  title: string;
  startDate: string;
  endDate: string;
  onStartDateChange: (date: string) => void;
  onEndDateChange: (date: string) => void;
  onCancel: () => void;
  onConfirm: () => void;
  confirmText?: string;
}

const AdminDateFilterModal: React.FC<AdminDateFilterModalProps> = ({
  title,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onCancel,
  onConfirm,
  confirmText = '적용',
}) => {
  const handleStartDateChange = (newStartDate: string) => {
    onStartDateChange(newStartDate);
    if (newStartDate && endDate && newStartDate > endDate) {
      onEndDateChange('');
    }
  };

  const handleEndDateChange = (newEndDate: string) => {
    onEndDateChange(newEndDate);
    if (startDate && newEndDate && startDate > newEndDate) {
      onStartDateChange('');
    }
  };

  return (
    <ModalOverlay onClick={onCancel}>
      <ModalCard $maxWidth="520px" onClick={(e) => e.stopPropagation()}>
        <ModalHeader>
          <ModalTitle>{title}</ModalTitle>
          <CloseButton onClick={onCancel}>×</CloseButton>
        </ModalHeader>
        <DateModalBody>
          <FormGroup>
            <FormLabel>시작일</FormLabel>
            <InputField type="date" value={startDate} onChange={(e) => handleStartDateChange(e.target.value)} max={endDate || undefined} />
          </FormGroup>
          <FormGroup>
            <FormLabel>종료일</FormLabel>
            <InputField type="date" value={endDate} onChange={(e) => handleEndDateChange(e.target.value)} min={startDate || undefined} />
          </FormGroup>
        </DateModalBody>
        <ModalFooter>
          <SecondaryButton onClick={onCancel}>취소</SecondaryButton>
          <PrimaryButton onClick={onConfirm}>{confirmText}</PrimaryButton>
        </ModalFooter>
      </ModalCard>
    </ModalOverlay>
  );
};

const DateModalBody = styled(ModalBody)`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export default AdminDateFilterModal;
